import { render } from "./XSvg.vue?vue&type=template&id=4a05f5da&ts=true"
import script from "./XSvg.vue?vue&type=script&lang=ts"
export * from "./XSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__